var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProfileEdit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1915 0C11.4712 0 10.7501 0.27598 10.2021 0.823843L0.444648 10.58C0.366595 10.658 0.318572 10.7611 0.309154 10.871L0.0015567 14.4932C-0.00963858 14.6303 0.0399555 14.7654 0.13726 14.8627C0.234564 14.9599 0.369744 15.0096 0.506918 14.9984L4.12958 14.6936C4.23965 14.6831 4.34239 14.6343 4.41982 14.5554L14.1781 4.79927C15.274 3.70355 15.274 1.91949 14.1781 0.823873C13.6302 0.27601 12.9118 0 12.1915 0ZM12.1915 0.930968C12.6693 0.930968 13.1471 1.11478 13.5172 1.4848C14.2573 2.22485 14.2573 3.3984 13.5172 4.13845L4.09021 13.5641L1.44081 10.9132L10.8667 1.48486C11.2367 1.11485 11.7138 0.930968 12.1915 0.930968ZM1.15881 11.9584L3.04653 13.8441L0.983882 14.0189L1.15881 11.9584Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileEdit);
export default __webpack_public_path__ + "static/media/profile-edit.7f7a3f73b628eb5727eb20f2a7b66857.svg";
export { ForwardRef as ReactComponent };